import React from 'react';
import { cn } from '../../../lib/utils';

interface ThemeButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: 'default' | 'primary' | 'secondary' | 'ghost' | 'destructive' | 'outline' | 'accent';
    size?: 'sm' | 'md' | 'lg' | 'icon';
}

export const ThemeButton = React.forwardRef<HTMLButtonElement, ThemeButtonProps>(
    ({ className, variant = 'default', size = 'md', ...props }, ref) => {
        const baseClasses = "inline-flex items-center justify-center rounded-md text-sm font-medium transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50";

        const variants = {
            default: "bg-primary text-primary-foreground hover:bg-primary/90",
            primary: "bg-primary text-primary-foreground hover:bg-primary/90",
            secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
            ghost: "hover:bg-accent hover:text-accent-foreground",
            destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
            outline: "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
            accent: "bg-accent text-accent-foreground hover:bg-accent/80"
        };

        const sizes = {
            sm: "h-8 px-3 text-xs",
            md: "h-10 px-4 py-2",
            lg: "h-11 px-8",
            icon: "h-10 w-10"
        };

        return (
            <button
                className={cn(baseClasses, variants[variant], sizes[size], className)}
                ref={ref}
                {...props}
            />
        );
    }
);

ThemeButton.displayName = "ThemeButton";
